import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const app = initializeApp({
  apiKey: 'AIzaSyDAyj0mjKcJqkQmGseRiaKTtXBuvbFt6ps',
  authDomain: 'milk-and-more-float-comp.firebaseapp.com',
  projectId: 'milk-and-more-float-comp',
  storageBucket: 'milk-and-more-float-comp.appspot.com',
  messagingSenderId: '962634854460',
  appId: '1:962634854460:web:3bca00f6b83da340e59339',
})

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
